import axios from "axios";
import React, { useEffect, useState } from "react";
import "@fontsource/roboto/400.css";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";
//import Link from "@mui/material/Link";
//import IconButton from "@mui/material/IconButton";
//import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";


function NuevoPedido() {
  //const [username, setUsername] = useState("");
  //const [email, setEmail] = useState("");
 //const [password, setPassword] = useState("");
  const [apiResponse, setApiResponse] = useState("");
  const [nombreOrigen, setnombreOrigen] = useState("");
  const [contactoOrigen, setcontactoOrigen] = useState("");
  const [direccionOrigen, setdireccionOrigen] = useState("");
  const [emailOrigen, setemailOrigen] = useState("");
  const [telefonoOrigen, settelefonoOrigen] = useState("");
  const [nombreDestino, setnombreDestino] = useState("");
  const [contactoDestino, setcontactoDestino] = useState("");
  const [direccionDestino, setdireccionDestino] = useState("");
  const [emailDestino, setemailDestino] = useState("");
  const [telefonoDestino, settelefonoDestino] = useState("");
  //const [newpedido, setNewPedidos] = useState([]);
  
  //const [altura, setaltura] = useState("");
  //const [ancho, setancho] = useState("");
  //const [largo, setlargo] = useState("");
  //const [peso, setpeso] = useState("");
  const loggedIn = sessionStorage.getItem("loggedIn");
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  //const clienteID = sessionStorage.getItem("email");
  const clienteid = userData?.clienteid;
  const navigate = useNavigate();
  
//Google Maps
  

//Google Maps

    useEffect(() => {
        if (!loggedIn) {
            navigate("/login");
        }
    }, []);


  const handlenombreOrigenChange = (event) => {
    setnombreOrigen(event.target.value);
  };

  const handlecontactoOrigenChange = (event) => {
    setcontactoOrigen(event.target.value);
  };

  const handleemailOrigenChange = (event) => {
    setemailOrigen(event.target.value);
  };

  const handledireccionOrigenChange = (event) => {
    setdireccionOrigen(event.target.value);
  };

  const handletelefonoOrigenChange = (event) => {
    settelefonoOrigen(event.target.value);
  };

  const handlenombreDestinoChange = (event) => {
    setnombreDestino(event.target.value);
  };

  const handlecontactoDestinoChange = (event) => {
    setcontactoDestino(event.target.value);
  };

  const handledireccionDestinoChange = (event) => {
    setdireccionDestino(event.target.value);
  };

  const handleemailDestinoChange = (event) => {
    setemailDestino(event.target.value);
  };

  const handletelefonoDestinoChange = (event) => {
    settelefonoDestino(event.target.value);
  };
  
  /*
  const handlealturaChange = (event) => {
    setaltura(event.target.value);
  };
  
  const handleanchoChange = (event) => {
    setancho(event.target.value);
  };
  
  const handlelargoChange = (event) => {
    setlargo(event.target.value);
  };
  
  const handlepesoChange = (event) => {
    setpeso(event.target.value);
  };
  
  
  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };
*/
  const handleSubmit = (event) => {
    event.preventDefault();

    axios
      .post("https://boxerlogistica.com/api/Nuevo_Pedido.php", {
        nombreOrigen: nombreOrigen,
        contactoOrigen: contactoOrigen,
        direccionOrigen: direccionOrigen,
        emailOrigen: emailOrigen,
        telefonoOrigen: telefonoOrigen,
        nombreDestino: nombreDestino,
        contactoDestino: contactoDestino,
        direccionDestino: direccionDestino,
        emailDestino: emailDestino,
        telefonoDestino: telefonoDestino,
        clienteid: clienteid
        //altura: altura,
        //ancho: ancho,
        //largo: largo,
        //peso: peso
      })
      .then((response) => {
       // console.log(response);
        setApiResponse(response.data.status);
        //setNewPedidos(response.data.data);
        const lastid = response.data.data.lastid;
        const seguimientoID = response.data.data.seguimientoID;

        sessionStorage.setItem("lastid", lastid);
        sessionStorage.setItem("seguimientoID", seguimientoID);
       
        //console.log(lastid);
        //console.log(seguimientoID);
        if (response.data.status === "success") {
          window.location.href = "/EnvioPaquete";
        }else{
          window.location.href = "/Envioerror";
        }
      })
      .catch((error) => {
        console.error(error);
        setApiResponse(error.response.data.message);
      });
  };



  return (

  <Container>
      <form onSubmit={handleSubmit}>
   {apiResponse && (
            <Alert
              style={{ marginBottom: "20px" }}
              severity={apiResponse.includes("success") ? "success" : "error"}
            >
              {apiResponse}
            </Alert>
          )}
          <div>
            <br></br>
            <br></br>
                        <Typography variant="h4" gutterBottom>
                            Ingresa tu dirección de origen (remitente) y la de destino (destinatario).
                        </Typography>
                            <br></br>  

          <div className=".Inicio-envio">
            <div className="envio-container" >
                        <div className="div-left_envio">
                            <div className="envio">
                                    De:
                                    <div className="row">
                                      <div className="col-25">
                                        <label for="nombreOrigen">Nombre Completo/Empresa</label>
                                      </div>
                                      <div className="col-75">
                                        <TextField
                                              type="text"
                                              value={nombreOrigen}
                                              onChange={handlenombreOrigenChange}
                                              variant="filled"
                                              id="filled-basic"
                                              label="Nombre Origen"
                                              fullWidth
                                              style={{ marginBottom: "20px" }}
                                            />
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-25">
                                        <label for="contactoOrigen">Nombre Contacto</label>
                                      </div>
                                      <div className="col-75">
                                        <TextField
                                              type="text"
                                              value={contactoOrigen}
                                              onChange={handlecontactoOrigenChange}
                                              variant="filled"
                                              id="filled-basic"
                                              label="Contacto Origen"
                                              fullWidth
                                              style={{ marginBottom: "20px" }}
                                            />
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-25">
                                        <label for="direccionOrigen">Dirección</label>
                                      </div>
                                      <div className="col-75">
                                        <TextField
                                              type="textarea"
                                              value={direccionOrigen}
                                              onChange={handledireccionOrigenChange}
                                              variant="filled"
                                              id="filled-basic"
                                              label="Direccion Origen"
                                              fullWidth
                                              style={{ marginBottom: "20px" }}
                                            />
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-25">
                                        <label for="emailOrigen">Email</label>
                                      </div>
                                      <div className="col-75">
                                        <TextField
                                              type="text"
                                              value={emailOrigen}
                                              onChange={handleemailOrigenChange}
                                              variant="filled"
                                              id="filled-basic"
                                              label="Email Origen"
                                              fullWidth
                                              style={{ marginBottom: "20px" }}
                                            />
                                      </div>
                                    </div> 
                                    <div className="row">
                                      <div className="col-25">
                                        <label for="telefonoOrigen">Telefono</label>
                                      </div>
                                      <div className="col-75">
                                        <TextField
                                              type="text"
                                              value={telefonoOrigen}
                                              onChange={handletelefonoOrigenChange}
                                              variant="filled"
                                              id="filled-basic"
                                              label="Telefono Origen"
                                              fullWidth
                                              style={{ marginBottom: "20px" }}
                                            />
                                      </div>
                                    </div> 
                                  </div>
                        </div>
                        <div className="div-right_envio">
                            <div className="envio">
                                 Para:
                                   <div className="row">
                                      <div className="col-25">
                                          <label for="nombreDestino">Nombre Completo/Empresa</label>
                                      </div>
                                      <div className="col-75">
                                         <TextField
                                            type="text"
                                            value={nombreDestino}
                                            onChange={handlenombreDestinoChange}
                                            variant="filled"
                                            id="filled-basic"
                                            label="nombreDestino"
                                            fullWidth
                                            style={{ marginBottom: "20px" }}
                                         />
                                      </div>
                                   </div>
                                   <div className="row">
                                      <div className="col-25">
                                         <label for="contactoDestino">Contacto</label>
                                      </div>
                                      <div className="col-75">
                                          <TextField
                                             type="text"
                                             value={contactoDestino}
                                             onChange={handlecontactoDestinoChange}
                                             variant="filled"
                                             id="filled-basic"
                                             label="contactoDestino"
                                             fullWidth
                                             style={{ marginBottom: "20px" }}
                                          />
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-25">
                                         <label for="direccionDestino">Dirección</label>
                                      </div>
                                      <div className="col-75">
                                         <TextField
                                            type="text"
                                            value={direccionDestino}
                                            onChange={handledireccionDestinoChange}
                                            variant="filled"
                                            id="filled-basic"
                                            label="direccionDestino"
                                            fullWidth
                                            style={{ marginBottom: "20px" }}
                                         />
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-25">
                                         <label for="emailDestino">Email</label>
                                      </div>
                                    <div className="col-75">
                                         <TextField
                                            type="text"
                                            value={emailDestino}
                                            onChange={handleemailDestinoChange}
                                            variant="filled"
                                            id="filled-basic"
                                            label="emailDestino"
                                            fullWidth
                                            style={{ marginBottom: "20px" }}
                                         />
                                    </div>
                                    </div>
                                    <div className="row">
                                       <div className="col-25">
                                          <label for="telefonoDestino">Telefono</label>
                                       </div>
                                       <div className="col-75">
                                          <TextField
                                              type="text"
                                              value={telefonoDestino}
                                              onChange={handletelefonoDestinoChange}
                                              variant="filled"
                                              id="filled-basic"
                                              label="telefonoDestino"
                                              fullWidth
                                              style={{ marginBottom: "20px" }}
                                          />
                                       </div>
                                    </div>
                                    
                            </div>               
                        </div>    
            </div>
            <div className="row">
              <br></br>
              <br></br>
              <Button variant="contained" type="submit">
                 Continuar
              </Button>
            </div>
          </div>
          </div>
        </form>
  </Container>          
  );
}

export default NuevoPedido;
